import * as React from "react";
const SvgWellnessfront = props => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" id="Wellness_front_svg__Layer_1" x={0} y={0} viewBox="0 0 244.6 153.1" {...props}><style>{".Wellness_front_svg__st3{fill:#ad9752}.Wellness_front_svg__st50{fill:#ab8b4c}"}</style><path d="M0 10.2C0 4.6 4.7 0 10.4 0h221.8c5.8 0 10.4 4.6 10.4 10.2v132.7c0 5.6-4.7 10.2-10.4 10.2H10.4c-5.8 0-10.4-4.6-10.4-10.2z" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }} /><path d="M0 9.1C0 4.1 4.1 0 9.1 0h226.3c5.1 0 9.1 4.1 9.1 9.1V144c0 5-4.1 9.1-9.1 9.1H9.1c-5 0-9.1-4.1-9.1-9.1z" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    stroke: "#231f20",
    strokeWidth: 0.25,
    strokeMiterlimit: 3.86
  }} /><linearGradient id="Wellness_front_svg__SVGID_1_" x1={191.845} x2={226.91} y1={38.401} y2={3.336} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
      stopColor: "#ada962"
    }} /><stop offset={0.16} style={{
      stopColor: "#c7c493"
    }} /><stop offset={0.5} style={{
      stopColor: "#fff"
    }} /><stop offset={0.62} style={{
      stopColor: "#e6e5d0"
    }} /><stop offset={0.8} style={{
      stopColor: "#c7c595"
    }} /><stop offset={0.93} style={{
      stopColor: "#b4b070"
    }} /><stop offset={1} style={{
      stopColor: "#ada962"
    }} /></linearGradient><path d="m201.6 125.3-7 16.7H190l-3.4-13.3c-.2-.8-.4-1.1-1-1.5-1-.6-2.8-1.1-4.3-1.4l.1-.5h7.4c.9 0 1.8.6 2 1.7l1.8 9.7 4.5-11.4h4.5zm17.9 11.3c0-4.4-6.1-4.6-6.1-6.6 0-.6.6-1.2 1.8-1.4.6-.1 2.3-.1 4.3.8l.8-3.5c-1-.4-2.4-.7-4-.7-4.3 0-7.3 2.3-7.3 5.5 0 2.4 2.1 3.8 3.8 4.6s2.2 1.3 2.2 2.1c0 1.1-1.4 1.6-2.6 1.6-2.2 0-3.4-.6-4.4-1.1l-.8 3.7c1 .5 2.9.9 4.8.9 4.5-.2 7.5-2.4 7.5-5.9m11.3 5.5h4l-3.5-16.7h-3.7c-.8 0-1.5.5-1.8 1.2l-6.5 15.5h4.5l.9-2.5h5.5l.6 2.5zm-4.8-6 2.3-6.3 1.3 6.3H226zm-18.2-10.7-3.6 16.7h-4.3l3.6-16.7h4.3z" style={{
    fill: "url(#Wellness_front_svg__SVGID_1_)",
    stroke: "#fff",
    strokeWidth: 0.15
  }} /><path d="M209.5 143.5v5.8h-.8v-5.8zM211 146.2v-1.1h.7v.7c.2-.4.7-.8 1.4-.8.6 0 1.5.4 1.5 1.8v2.5h-.8v-2.4c0-.7-.2-1.2-1-1.2-.5 0-.9.4-1 .8 0 .1-.1.2-.1.4v2.5h-.7zM216.1 149.3v-3.6h-.6v-.6h.6v-.2c0-.6.1-1.1.5-1.5.3-.3.7-.4 1-.4s.5.1.6.1l-.1.6c-.1-.1-.3-.1-.5-.1-.6 0-.8.6-.8 1.2v.2h1v.6h-1v3.6zM219.1 144.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5m-.4 4.9v-4.2h.8v4.2zM221 146.2v-1.1h.7v.7c.2-.4.7-.8 1.4-.8.6 0 1.5.4 1.5 1.8v2.5h-.8v-2.4c0-.7-.2-1.2-1-1.2-.5 0-.9.4-1 .8 0 .1-.1.2-.1.4v2.5h-.7zM226.4 144.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5m-.4 4.9v-4.2h.8v4.2zM229.1 144.1v1h1.1v.6h-1.1v2.2c0 .5.1.8.6.8.2 0 .3 0 .4-.1v.6c-.1.1-.4.1-.7.1-.4 0-.6-.1-.8-.3s-.3-.6-.3-1.1v-2.3h-.6v-.6h.6v-.8zM231.7 147.3c0 1 .7 1.4 1.4 1.4.5 0 .9-.1 1.2-.2l.1.5c-.3.1-.7.3-1.4.3-1.3 0-2.1-.9-2.1-2.1s.8-2.3 2-2.3c1.4 0 1.7 1.2 1.7 2v.4zm2.2-.5c0-.5-.2-1.2-1.1-1.2-.8 0-1.1.7-1.2 1.2z" className="Wellness_front_svg__st3" /><defs><path id="Wellness_front_svg__SVGID_00000178916359687800336180000009307442169261889673_" d="M0 9.1C0 4.1 4.1 0 9.1 0h226.3c5.1 0 9.1 4.1 9.1 9.1V144c0 5-4.1 9.1-9.1 9.1H9.1c-5 0-9.1-4.1-9.1-9.1z" /></defs><clipPath id="Wellness_front_svg__SVGID_00000026873344118432549820000011805336943034285708_"><use xlinkHref="#Wellness_front_svg__SVGID_00000178916359687800336180000009307442169261889673_" style={{
      overflow: "visible"
    }} /></clipPath><g style={{
    clipPath: "url(#Wellness_front_svg__SVGID_00000026873344118432549820000011805336943034285708_)"
  }}><linearGradient id="Wellness_front_svg__SVGID_00000073716623504707848310000013374341662687967878_" x1={15.213} x2={157.503} y1={77.167} y2={57.177} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M29.8 3.9c-1.9 5.2-3.4 10.5-4.8 15.9-1.3 5.4-2.5 10.8-3.2 16.2-.4 2.7-.7 5.5-.9 8.2s-.3 5.5-.3 8.2c.1 5.5.8 11 2.5 16.2.9 4.3 1.8 8.7 2.9 12.9s2.4 8.5 3.8 12.7v-.1c1.3 2.7 2.5 5.4 3.6 8.2 1 2.8 2 5.7 2.6 8.6.7 2.9 1.2 5.9 1.1 8.9s-.6 6.2-2.6 8.7l-.4-1c5.1.8 9.8 2.7 14.3 5 2.2 1.2 4.4 2.5 6.5 3.8 2.1 1.4 4.2 2.8 6.2 4.2 4.2 2.7 8.5 5.3 12.9 7.7s8.9 4.7 13.6 6.3c4.7 1.9 9.6 3.5 14.5 5s9.8 2.8 14.8 3.9 10 2.1 15.1 2.6c2.6.2 5.1.3 7.7.4 1.3 0 2.6.1 3.8 0 1.3 0 2.6-.1 3.8-.3-1.3.2-2.5.3-3.8.3-1.3.1-2.6.1-3.8 0-2.6 0-5.1-.1-7.7-.2-5.1-.4-10.2-1.4-15.2-2.4-5-1.1-10-2.3-14.9-3.8-4.9-1.4-9.8-3-14.6-4.9-4.8-1.6-9.4-3.8-13.8-6.2s-8.7-5-13-7.7c-2.1-1.4-4.2-2.7-6.3-4.2-2.1-1.3-4.2-2.6-6.5-3.8-2.2-1.1-4.5-2.1-6.8-3-2.3-.8-4.8-1.6-7.1-1.9l-1-.1.6-.8c1.7-2.2 2.3-5.2 2.4-8 0-2.9-.4-5.8-1.1-8.7s-1.5-5.7-2.6-8.4c-1-2.8-2.2-5.5-3.5-8.1-1.5-4.2-2.7-8.5-3.8-12.8s-2.1-8.6-2.9-13v.1c-1.7-5.3-2.4-10.9-2.4-16.5 0-2.8.1-5.5.4-8.3.2-2.8.6-5.5 1-8.2.9-5.5 2.1-10.9 3.5-16.2 1.8-5 3.4-10.2 5.4-15.4" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000073716623504707848310000013374341662687967878_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000129923300072404676880000015258674010677201287_" x1={9.728} x2={113.068} y1={23.452} y2={8.932} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M17.3 103.5c-.8 3.5-1.4 7.1-1.9 10.6-.5 3.6-.8 7.1-.8 10.7 0 .9.1 1.8.1 2.7.1.9.2 1.7.3 2.7.2 1.8.1 3.7-.2 5.5s-.9 3.6-1.8 5.2-2.1 3.1-3.6 4.2l-.2-.9c5.7.9 11.4 1.9 17 2.9 2.8.5 5.7 1 8.5 1.6s5.6 1.1 8.5 2c5.5 1.6 11.1 3.2 16.6 4.8 5.5 1.7 11.1 3.3 16.4 5.4 5.4 1.9 10.9 3.7 16.4 5.4s11 3.4 16.6 4.8c-5.7-1.1-11.2-2.7-16.8-4.2-5.5-1.6-11.1-3.3-16.5-5.1-2.7-1-5.4-1.9-8.2-2.7-2.8-.9-5.5-1.7-8.3-2.5-5.5-1.6-11.1-3.2-16.6-4.7-1.3-.4-2.7-.8-4.1-1.1l-4.2-.9c-2.8-.6-5.6-1.1-8.5-1.6-5.7-1.1-11.3-2.1-17-3l-1.2-.3.9-.7c1.4-1 2.6-2.3 3.4-3.8.9-1.5 1.4-3.2 1.8-4.9.3-1.7.4-3.5.3-5.3l-.3-2.7c0-.9-.1-1.8-.1-2.7 0-3.6.5-7.2 1.1-10.8.7-3.5 1.5-7.1 2.4-10.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000129923300072404676880000015258674010677201287_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000024711664410884397830000005612770440997850813_" x1={-6.721} x2={125.966} y1={31.479} y2={12.838} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="m121 176-32.8-6-32.8-6.2c-6.3-1.7-12.7-3.2-19.1-4.4-3.2-.6-6.4-1.2-9.7-1.6-3.2-.4-6.5-.7-9.7-.7-4.7-.5-9.5-.8-14.3-.8-2.4 0-4.8 0-7.1.3-1.2.1-2.3.3-3.5.6-1.1.3-2.2.7-2.9 1.4l-.8-.8c2.2-2.1 4.2-4.6 5.9-7.2 1.8-2.6 3.2-5.4 4.6-8.2 2.7-5.7 4.6-11.8 6-18l1-4.7.7-4.7.3-2.4c.1-.8.1-1.6.2-2.4l.4-4.8c.1-.8.1-1.6.1-2.4v-2.4l.1-4.8-.4-9.5.7 9.5v7.2c0 .8 0 1.6-.1 2.4l-.3 4.8c-.1.8-.1 1.6-.2 2.4l-.2 2.4-.6 4.8-.9 4.7c-1.3 6.2-3.2 12.4-5.9 18.2-1.4 2.9-2.9 5.7-4.7 8.4s-3.7 5.2-6.1 7.5l-.8-.8c1-1.1 2.3-1.4 3.5-1.7q1.8-.45 3.6-.6 3.6-.3 7.2-.3c4.8 0 9.6.3 14.4.8h-.1c3.3 0 6.6.3 9.9.7s6.5 1 9.7 1.6q4.8.9 9.6 2.1l9.6 2.4 32.7 6.5z" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000024711664410884397830000005612770440997850813_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000037660922994721547190000002348696427008744375_" x1={6.029} x2={170.239} y1={55.321} y2={32.241} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M162.6 175.1c-7.2-.1-14.4-.6-21.6-1.3s-14.4-1.6-21.5-2.9c-1.8-.3-3.6-.7-5.3-1-1.8-.4-3.6-.7-5.3-1.2l-5.3-1.3-5.2-1.5c-6.9-2.2-13.7-4.8-20-8.5-2.1-1.5-4.4-2.8-6.8-4q-3.45-1.8-7.2-3.3c-4.9-2-9.9-3.7-15-5.2l-3.8-1-3.9-.9c-2.6-.6-5.2-1.1-7.8-1.6s-5.2-.8-7.8-1.3c-2.6-.3-5.2-.6-7.9-.9l-1.6-.2 1.4-.9c1-.6 1.9-1.6 2.6-2.7.3-.6.7-1.1 1-1.7s.6-1.2.8-1.8c.9-2.4 1.4-5.1 1.7-7.7.1-1.3.2-2.7.1-4v-2l-.1-2-.1-2-.3-2-.2-2c-.1-.7-.3-1.3-.4-2l-7-31.4v.1c-1-2.8-1.5-5.7-1.9-8.6s-.6-5.8-.7-8.8 0-5.9.2-8.8c.1-1.5.2-2.9.4-4.4l.5-4.4-.6 4.4c-.1 1.5-.2 2.9-.3 4.4-.1 2.9-.2 5.8 0 8.8.1 2.9.4 5.8.8 8.7.5 2.9 1.1 5.8 2.1 8.4L24 108c.1.7.3 1.3.5 2l.3 2 .3 2 .2 2 .1 2v2c.1 1.4-.1 2.7-.1 4.1-.3 2.7-.7 5.4-1.7 8s-2.3 5.1-4.9 6.7l-.2-1.1c2.6.3 5.3.6 7.9.9 2.6.4 5.3.7 7.9 1.2s5.2.9 7.8 1.6l3.9.9 3.8 1.1c5.1 1.5 10.2 3.2 15.1 5.3 2.4 1.1 4.9 2.1 7.2 3.4 2.4 1.2 4.7 2.6 6.9 4.1h-.1c6.2 3.6 12.9 6.3 19.7 8.5l5.2 1.6 5.2 1.4c1.7.5 3.5.8 5.3 1.2s3.5.8 5.3 1.1l5.3 1 5.3.8c3.6.5 7.1 1 10.7 1.4 7.3 1 14.5 1.6 21.7 1.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000037660922994721547190000002348696427008744375_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000081609898800044012240000010293304656858715795_" x1={34.982} x2={178.152} y1={98.26} y2={77.33} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M164.6 167.5c-5.4-3.1-11.1-5.5-17.1-7-3-.8-6-1.3-9.1-1.4-1.5 0-3.1.1-4.6.1-1.6.1-3.1.1-4.6.1-6.2-.1-12.4-.7-18.5-1.9s-12.1-3.1-17.6-6c-4.4-1.8-8.7-3.8-13-6-4.2-2.2-8.4-4.6-12.4-7.1-4-2.6-7.9-5.4-11.5-8.5-3.6-3.2-7-6.6-9.8-10.5l-.1-.2v-.1c.2-3.2-.1-6.5-.4-9.7-.4-3.2-.9-6.5-1.5-9.7q-.9-4.8-2.1-9.6l-1.2-4.8c-.4-1.6-.8-3.2-1.1-4.8-2.6-12.9-3.2-26.2-2.4-39.3.1-1.6.3-3.3.5-4.9l.2-2.5.4-2.4.7-4.9 1-4.8.5-2.4.6-2.4 1.2-4.8c.8-3.2 1.5-6.4 2.2-9.6 1.4-6.4 2.6-12.8 3.6-19.3s1.7-13 1.5-19.6c.3 6.6-.3 13.1-1.2 19.6s-2 13-3.3 19.4c-.7 3.2-1.4 6.4-2.2 9.6L42.1 17l-.6 2.4-.5 2.4-.9 4.8-.7 4.9-.3 2.4-.2 2.4c-.1 1.6-.3 3.3-.4 4.9-.8 13-.1 26.2 2.5 39 .3 1.6.7 3.2 1.1 4.8l1.2 4.8q1.2 4.8 2.1 9.6c.6 3.2 1.2 6.5 1.5 9.8s.6 6.6.4 9.9l-.1-.4c2.8 3.8 6.1 7.2 9.6 10.3q5.4 4.65 11.4 8.4c4 2.6 8.1 4.9 12.3 7.1s8.5 4.3 12.8 6.1c5.4 2.9 11.3 4.8 17.3 6s12.2 1.9 18.4 2h4.6c1.5-.1 3.1-.1 4.6-.1 3.1.1 6.2.7 9.2 1.5 6.2 1.9 11.9 4.4 17.2 7.5" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000081609898800044012240000010293304656858715795_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000037690562795019687430000016624150892172845444_" x1={48.595} x2={188.145} y1={106.653} y2={86.591} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M176.9 144.7c-2.8-.6-5.7-1-8.6-1.1s-5.8 0-8.6.5c-.7.1-1.4.2-2.1.4l-2.1.6c-1.4.4-2.8.7-4.2 1.1-2.8.7-5.6 1.3-8.5 1.9-5.7 1.1-11.4 1.9-17.2 2.2s-11.7.1-17.3-1.4h.1c-5-.6-9.9-1.6-14.8-3-2.4-.7-4.8-1.4-7.1-2.5-2.3-1-4.5-2.2-6.7-3.5-4.3-2.6-8.3-5.6-12.4-8.5-4-2.9-8-6.3-10.7-10.6v.1l-3-3.7c-3.4-6.2-5.8-13-7.3-19.9-1.4-6.9-1.9-14.1-1.5-21.1.3-7.1 1.5-14.1 3.3-20.9s4.2-13.5 7-20 6.1-12.7 9.9-18.7c.9-1.5 1.9-3 2.9-4.4 1.1-1.4 1.9-2.9 2.9-4.4.7-1.8 1.7-3.2 2.5-4.8.8-1.5 1.8-3 2.5-4.6 3.2-6.2 5.9-12.8 7.7-19.6l.6-2.6c.2-.9.3-1.7.5-2.6l.2-1.3.2-1.3c.1-.9.3-1.7.3-2.6.3-3.5.4-7-.2-10.5.6 3.5.6 7 .3 10.5 0 .9-.2 1.8-.3 2.6l-.2 1.3v1.5c-.2.9-.3 1.7-.5 2.6l-.6 2.6c-1.7 6.9-4.2 13.5-7.4 19.8-.8 1.6-1.7 3.1-2.5 4.7s-1.8 3.1-2.7 4.6-1.8 3-2.8 4.5c-1 1.4-1.9 2.9-2.8 4.4-3.6 6-6.9 12.2-9.6 18.7-1.4 3.2-2.7 6.5-3.8 9.8s-2.2 6.7-3 10.1c-1.7 6.8-2.9 13.7-3.2 20.7-.7 13.9 2 28.2 8.7 40.5v-.1l3 3.7c2.6 4.2 6.4 7.4 10.4 10.4 4.1 2.9 8.1 5.9 12.3 8.5 2.1 1.3 4.3 2.5 6.6 3.4 2.3 1 4.6 1.8 7 2.5 4.8 1.4 9.7 2.4 14.6 3.1 5.5 1.5 11.3 1.7 17.1 1.5s11.5-1 17.2-2c2.8-.5 5.7-1.1 8.5-1.7 1.4-.3 2.8-.7 4.2-1q2.1-.6 4.2-.9c2.9-.5 5.8-.5 8.7-.4 2.6-.2 5.5.2 8.3.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000037690562795019687430000016624150892172845444_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000035489850013656825810000017679658593891747004_" x1={50.477} x2={168.477} y1={79.525} y2={62.945} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M165.9 45.4c-1.3-2.1-3-4-4.8-5.6-1.9-1.6-3.9-3-6.1-4.2-4.3-2.4-9.1-3.9-14-4.7-9.8-1.6-19.7-.6-29.3 1.4-4.8 1.1-9.5 2.4-14.2 4-2.3.8-4.7 1.6-6.9 2.5-2.3.9-4.5 1.9-6.7 3-8.7 4.4-16.7 10.4-22.5 18-2.9 3.8-5.1 8.1-6.5 12.6s-1.9 9.3-1.6 14c.1 2.4.5 4.7 1 7.1l.9 3.5c.3 1.2.7 2.3 1.1 3.4l.7 1.6.7 1.7c.5 1.1.9 2.2 1.4 3.3l1.6 3.2.8 1.5c.3.5.6.9 1 1.4 5.7 7.6 13.6 13.6 22.5 16.9s18.8 3.3 28.2 1.1h.2c2.1-.4 4.4-1 6.5-1.8l1.6-.6 1.6-.7 1.6-.7 1.5-.8c2.1-1 4-2.3 6-3.5 1.9-1.4 3.9-2.6 5.6-4.1 7.2-5.8 13.4-13 18.5-20.8l1.9-2.9c.6-1 1.1-2 1.7-3.1l1.7-3.1.9-1.5c.3-.5.5-1.1.8-1.6 1.9-4.3 4.2-8.4 5.3-13 1.2-4.5 1.7-9.3 1.3-14-.5-4.8-1.7-9.4-4-13.5m0 0c2.3 4.1 3.6 8.8 4 13.5.2 2.3.2 4.7 0 7.1-.2 2.3-.6 4.7-1.1 7-1 4.6-3.3 8.8-5.1 13.2-.2.5-.5 1.1-.7 1.6l-.8 1.6-1.6 3.1c-.6 1.1-1.1 2.1-1.6 3.1l-1.9 3c-4.9 8.1-10.9 15.6-18.1 21.8-1.7 1.6-3.7 3-5.6 4.4-2 1.3-4 2.7-6.1 3.8l-1.6.9-1.6.8-1.6.8c-.6.2-1.1.5-1.7.7-2.2.9-4.5 1.7-7 2.2h.2c-4.9 1.4-9.9 2.1-15.1 2.1-1.3 0-2.6-.1-3.8-.2-1.3-.1-2.6-.2-3.8-.5-2.5-.4-5-1.1-7.5-1.9-4.9-1.6-9.4-4.1-13.6-7.2-4.1-3.1-7.8-6.7-10.9-10.8-.4-.5-.8-1.1-1.1-1.6l-.1-.2v-.1l-.1-.2-.2-.4-.4-.9-1.7-3.4c-.5-1.2-1-2.3-1.5-3.5l-.7-1.8-.6-1.8c-1.7-4.8-2.8-9.8-3-15-.2-5.1.4-10.3 2-15.2s4.2-9.5 7.4-13.4c6.5-7.9 14.9-13.8 24-18 2.3-1.1 4.6-2 6.9-2.9 2.4-.8 4.7-1.5 7.1-2.2 4.8-1.4 9.6-2.6 14.5-3.5 9.8-1.7 19.8-2.5 29.6-.7 4.9 1 9.6 2.5 14 4.9 2.2 1.2 4.2 2.6 6 4.3 1.6 1.5 3.3 3.4 4.5 5.5" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000035489850013656825810000017679658593891747004_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000109024713015415996420000014474661520589014451_" x1={133.89} x2={167.29} y1={97.855} y2={93.155} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M168.1 50.2c-2.7 1.7-5.5 3.2-8.4 4.6-2.8 1.4-5.7 2.7-8.6 4-2.9 1.2-5.9 2.5-8.8 3.5-3 1.1-6 2.1-9.1 2.9 2.7-1.7 5.5-3.2 8.4-4.6 2.8-1.4 5.7-2.7 8.6-4 2.9-1.2 5.9-2.5 8.8-3.5 2.9-1.1 5.9-2.1 9.1-2.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000109024713015415996420000014474661520589014451_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000046298196264485897250000013477873540589151138_" x1={125.339} x2={165.409} y1={91.281} y2={85.651} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M166.2 58.2c-3.2 1.9-6.5 3.5-9.8 5.1s-6.8 2.9-10.2 4.2c-3.5 1.2-7 2.4-10.6 3.2-1.8.4-3.6.8-5.5 1-.9.1-1.9.1-2.8.1-.9-.1-1.9-.2-2.7-.8.8.4 1.8.3 2.7.2s1.8-.3 2.7-.5c1.8-.4 3.5-1 5.2-1.5 1.7-.6 3.4-1.2 5.2-1.8 1.7-.6 3.4-1.2 5.1-1.9 6.8-2.5 13.6-5.1 20.7-7.3" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000046298196264485897250000013477873540589151138_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000015356965482568437290000013453952564641887370_" x1={116.721} x2={163.491} y1={84.522} y2={77.942} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M164.3 66.2c-3.7 2.1-7.5 3.9-11.4 5.5S145 74.8 141 76c-4.1 1.2-8.2 2.2-12.5 2.6-2.1.2-4.3.3-6.4.1-2.1-.3-4.3-.8-5.9-2.2 1.8 1.1 3.9 1.3 6 1.4 2.1 0 4.1-.2 6.2-.6 2.1-.3 4.1-.8 6.1-1.3s4-1.1 6-1.7q6-1.8 12-3.9z" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000015356965482568437290000013453952564641887370_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000044149767843668278560000012187558874895604136_" x1={108.079} x2={161.549} y1={77.652} y2={70.132} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M162.4 74.2c-4.2 2.3-8.6 4.2-13.1 6-4.5 1.7-9.1 3.2-13.8 4.3s-9.5 1.8-14.3 1.8c-2.4 0-4.9-.3-7.2-.9s-4.6-1.6-6.4-3.2c2 1.3 4.3 2.1 6.6 2.5s4.7.5 7 .4c2.4-.1 4.7-.3 7.1-.7 2.3-.4 4.7-.8 7-1.4 4.6-1.1 9.2-2.4 13.7-3.9 4.4-1.5 8.9-3.1 13.4-4.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000044149767843668278560000012187558874895604136_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000164480777563356291350000010999424785849976977_" x1={99.439} x2={159.609} y1={70.751} y2={62.291} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M160.5 82.2c-4.7 2.5-9.7 4.6-14.8 6.4s-10.3 3.2-15.6 4.1-10.8 1.3-16.2.7c-2.7-.3-5.4-.9-7.9-1.8-2.5-1-4.9-2.2-7-3.9 2.2 1.5 4.7 2.6 7.2 3.4s5.2 1.3 7.8 1.4c2.7.2 5.3.2 8 0s5.3-.5 7.9-1c5.3-.9 10.4-2.2 15.5-3.8 2.6-.8 5.1-1.7 7.6-2.6 2.5-.8 5-1.8 7.5-2.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000164480777563356291350000010999424785849976977_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000046328678284434554100000004397784122697344942_" x1={90.79} x2={157.66} y1={63.793} y2={54.403} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M158.6 90.2c-5.3 2.7-10.9 4.9-16.5 6.7-5.7 1.8-11.5 3.1-17.5 3.8-3 .3-6 .5-9 .5-3-.1-6-.2-8.9-.8s-5.8-1.4-8.6-2.6c-2.7-1.2-5.3-2.8-7.7-4.6q3.75 2.55 7.8 4.2c2.8 1.1 5.6 1.8 8.5 2.3s5.9.7 8.8.7 5.9-.2 8.8-.5c5.9-.6 11.7-2 17.4-3.6 2.9-.8 5.7-1.8 8.5-2.8 3-1 5.7-2.1 8.4-3.3" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000046328678284434554100000004397784122697344942_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000019675207704278757370000017593426288715664002_" x1={82.139} x2={155.699} y1={56.831} y2={46.491} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M156.7 98.2c-5.8 3-12 5.3-18.3 7.1s-12.8 3-19.3 3.5c-3.3.2-6.6.2-9.8 0-3.3-.3-6.5-.7-9.7-1.5q-4.8-1.2-9.3-3.3c-3-1.4-5.7-3.2-8.3-5.2 2.7 1.9 5.5 3.6 8.5 4.9s6.1 2.4 9.2 3.1c3.2.7 6.4 1.2 9.7 1.4 3.2.2 6.5.2 9.8-.1 6.5-.4 13-1.6 19.2-3.3 3.1-.8 6.3-1.8 9.3-2.9s6.1-2.3 9-3.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000019675207704278757370000017593426288715664002_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000173881891323871967600000017754925710354990228_" x1={78.78} x2={152.55} y1={53.565} y2={43.205} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M153.6 101.8c-5.9 3-12.1 5.3-18.4 7.1s-12.9 2.9-19.5 3.2q-4.95.15-9.9-.3c-3.3-.3-6.5-1-9.7-1.9s-6.2-2.2-9.2-3.7c-2.9-1.5-5.6-3.4-8.2-5.5 5.2 4 11.1 7 17.5 8.8 3.2.8 6.4 1.5 9.6 1.8 3.3.3 6.5.4 9.8.2 6.5-.3 13-1.4 19.4-3.1 3.2-.8 6.3-1.8 9.4-2.9 3.2-1 6.2-2.2 9.2-3.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000173881891323871967600000017754925710354990228_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000034071948956393316270000014474455878331130519_" x1={75.42} x2={149.41} y1={50.306} y2={39.906} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M150.4 105.5c-5.9 3-12.1 5.3-18.5 7s-13 2.7-19.6 2.9c-6.6.1-13.3-.7-19.6-2.8-3.2-1-6.2-2.4-9.1-4s-5.5-3.7-8-5.8c5.1 4.2 10.9 7.5 17.2 9.5s12.9 2.8 19.5 2.6c6.6-.1 13.1-1.1 19.5-2.8 3.2-.8 6.4-1.8 9.4-2.9 3.1-1.1 6.2-2.3 9.2-3.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000034071948956393316270000014474455878331130519_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000182528494822459044830000013362517437560968891_" x1={72.061} x2={146.251} y1={47.015} y2={36.585} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M147.2 109.1c-5.9 3-12.2 5.3-18.6 6.9-6.4 1.7-13.1 2.6-19.7 2.6-3.3 0-6.7-.3-9.9-.9-3.3-.5-6.5-1.4-9.6-2.6-3.1-1.1-6.1-2.6-8.9-4.4l-2.1-1.4-2-1.5-1-.8-.9-.8-1.9-1.7 1.9 1.6.9.8 1 .7 2 1.5 2.1 1.3c2.8 1.7 5.8 3.2 8.9 4.3s6.3 2 9.6 2.5 6.6.8 9.9.8c6.6 0 13.2-.8 19.7-2.4 3.2-.8 6.4-1.8 9.5-2.9 3-.9 6.1-2.2 9.1-3.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000182528494822459044830000013362517437560968891_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000180363110173772887310000005338787014994722749_" x1={68.689} x2={143.099} y1={43.67} y2={33.22} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M144 112.7c-5.9 3.1-12.3 5.3-18.8 6.9s-13.2 2.4-19.9 2.3c-3.3-.1-6.7-.5-10-1.2-1.7-.3-3.3-.8-4.9-1.2-1.6-.6-3.2-1-4.7-1.7-6.2-2.5-11.8-6.4-16.6-11.1 2.5 2.2 5 4.4 7.8 6.2l1 .7 1.1.6c.7.4 1.4.8 2.2 1.2 1.5.7 3 1.5 4.5 2.1 1.5.7 3.1 1.1 4.7 1.7 1.6.4 3.2.9 4.9 1.2 3.3.6 6.6 1 9.9 1.1 6.7.2 13.3-.6 19.8-2.1 3.2-.8 6.5-1.7 9.6-2.8s6.4-2.4 9.4-3.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000180363110173772887310000005338787014994722749_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000159444882420654516020000014249684246851672478_" x1={65.331} x2={139.941} y1={40.343} y2={29.853} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M140.8 116.3c-6 3.1-12.4 5.3-18.9 6.9-6.6 1.5-13.3 2.3-20 1.9-1.7-.1-3.4-.3-5-.5-1.7-.3-3.3-.5-5-1-3.3-.8-6.5-1.8-9.6-3.3-6.2-2.7-11.6-6.9-16.3-11.7 2.4 2.3 4.9 4.6 7.7 6.5 1.3 1 2.8 1.8 4.2 2.7.7.4 1.5.8 2.2 1.2.4.2.7.4 1.1.6l1.2.5c3 1.4 6.3 2.4 9.5 3.2 1.6.4 3.3.7 4.9.9 1.7.2 3.3.4 5 .4 6.7.4 13.4-.3 20-1.8 3.3-.7 6.5-1.7 9.7-2.8 3.2-.9 6.4-2.2 9.3-3.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000159444882420654516020000014249684246851672478_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000108298256853237737860000004378889150242376863_" x1={61.959} x2={136.78} y1={36.992} y2={26.472} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M137.7 119.9c-6 3.1-12.5 5.3-19.1 6.8-6.6 1.4-13.4 2.1-20.2 1.6S85 126 78.9 122.9c-6.1-3-11.4-7.3-16-12.3 2.4 2.4 4.8 4.8 7.5 6.8 2.7 2.1 5.6 3.8 8.6 5.4 6.1 3 12.7 4.8 19.4 5.3 6.7.6 13.5 0 20.1-1.4 3.3-.7 6.6-1.6 9.8-2.7 3.2-1.3 6.3-2.5 9.4-4.1" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000108298256853237737860000004378889150242376863_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000041291116987726692570000003196453957039836086_" x1={135.551} x2={150.711} y1={103.76} y2={101.63} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M151.9 36.8c-1.1 2.5-2.4 4.9-3.8 7.3-1.3 2.4-2.8 4.7-4.2 7-1.5 2.3-3 4.6-4.6 6.8s-3.2 4.4-5 6.5c1.1-2.5 2.4-4.9 3.8-7.3 1.3-2.4 2.8-4.7 4.2-7 1.5-2.3 3-4.6 4.6-6.8 1.6-2.3 3.2-4.5 5-6.5" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000041291116987726692570000003196453957039836086_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000020358837139482972350000011724443382952255904_" x1={126.47} x2={141.84} y1={101.237} y2={99.077} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M143.6 36.4c-3.4 5.6-7 11-10.4 16.4-1.7 2.7-3.4 5.5-5 8.3-.8 1.4-1.5 2.8-2.1 4.3-.3.7-.6 1.5-.8 2.3s-.3 1.6.1 2.3c-.5-.7-.6-1.6-.5-2.4 0-.4.1-.8.2-1.2l.3-1.2c.4-1.6 1-3.1 1.7-4.6 1.4-3 3-5.8 4.7-8.6 1.8-2.8 3.6-5.4 5.6-8s4-5.3 6.2-7.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000020358837139482972350000011724443382952255904_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000058553040062773096980000005087562350085938344_" x1={116.85} x2={132.989} y1={98.782} y2={96.512} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M135.3 36c-2.3 3.1-4.5 6.2-6.7 9.2-2.2 3.1-4.3 6.2-6.2 9.5-1 1.6-1.9 3.2-2.8 4.9s-1.7 3.4-2.3 5.1q-1.05 2.55-1.5 5.4c-.3 1.8-.1 3.8.8 5.5-1.2-1.5-1.5-3.6-1.5-5.5.1-1.9.5-3.9 1.1-5.7 1.2-3.7 3-7.1 4.9-10.4 2-3.3 4.2-6.4 6.6-9.4 2.3-3.1 4.9-6 7.6-8.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000058553040062773096980000005087562350085938344_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000108294674187368635780000007332121158143368087_" x1={106.969} x2={124.129} y1={96.371} y2={93.961} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M127 35.6c-1.4 1.7-2.8 3.3-4.2 5s-2.7 3.4-4 5.2c-2.6 3.5-5 7.1-7.2 10.9-1.1 1.9-2.1 3.8-2.9 5.8-.9 2-1.6 4-2.1 6.1s-.8 4.2-.7 6.4.7 4.3 1.8 6.2c-1.3-1.8-2.1-3.9-2.4-6.1s-.1-4.5.3-6.7c.8-4.4 2.7-8.5 4.9-12.3s4.7-7.5 7.5-10.9c1.4-1.7 2.8-3.4 4.3-5s3-3.2 4.7-4.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000108294674187368635780000007332121158143368087_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000094601219154333190420000007124516740483105692_" x1={96.962} x2={115.292} y1={93.989} y2={91.418} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M118.6 35.2c-1.7 1.8-3.4 3.6-5 5.5s-3.2 3.8-4.7 5.7c-3 3.9-5.8 8-8.1 12.4-1.2 2.2-2.2 4.4-3 6.7s-1.4 4.7-1.7 7.1c-.7 4.8.2 9.9 2.7 14.2-1.4-2-2.5-4.3-3.1-6.8-.6-2.4-.7-5-.5-7.5.5-5 2.3-9.8 4.6-14.2 1.2-2.2 2.5-4.3 3.9-6.4q2.1-3.15 4.5-6c3.2-3.9 6.6-7.5 10.4-10.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000094601219154333190420000007124516740483105692_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000043434829897041847810000005736372978254720947_" x1={86.879} x2={106.459} y1={91.586} y2={88.836} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M110.3 34.8c-2.1 1.9-4 3.8-5.9 5.9q-2.85 3-5.4 6.3c-3.4 4.3-6.6 8.9-8.9 13.9-2.4 4.9-4.1 10.3-4.3 15.8-.1 2.7.2 5.5.9 8.2s1.9 5.2 3.3 7.6c-1.6-2.3-2.8-4.8-3.7-7.5-.8-2.7-1.2-5.5-1.1-8.3 0-2.8.5-5.6 1.2-8.3q1.05-4.05 3-7.8c2.5-5 5.6-9.7 9.2-13.9 3.5-4.5 7.4-8.4 11.7-11.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000043434829897041847810000005736372978254720947_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000011749668057563257530000008387123421067022223_" x1={76.759} x2={97.629} y1={89.209} y2={86.279} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M102 34.4c-2.4 1.9-4.6 4-6.8 6.2s-4.2 4.5-6.1 6.8c-3.8 4.8-7.3 9.9-9.7 15.5-1.2 2.8-2.3 5.7-2.9 8.6-.7 3-.9 6-.8 9.1.2 6.1 2.2 12.1 5.5 17.3l-1.2-2-.6-1-.5-1c-.3-.7-.7-1.4-1-2.1l-.8-2.2c-1-2.9-1.7-6-1.8-9.1-.2-3.1.2-6.2.8-9.2s1.7-5.9 2.9-8.8c2.5-5.6 6-10.8 9.9-15.5 3.8-4.5 8.3-8.9 13.1-12.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000011749668057563257530000008387123421067022223_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000180344080571307396890000001553088171606771092_" x1={73.011} x2={92.571} y1={86.871} y2={84.121} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M96.9 36.9c-2.3 1.9-4.5 4-6.6 6.2s-4.1 4.5-6 6.8c-3.7 4.8-7 9.9-9.2 15.5-1.1 2.8-2 5.7-2.6 8.7-.5 3-.6 6-.4 9 .4 6 2.8 11.8 6.1 16.9L77 98.1l-.6-1c-.2-.3-.4-.7-.5-1l-1.1-2-1-2.1c-1.1-2.8-1.9-5.8-2.2-8.9-.3-3-.2-6.1.3-9.1s1.4-5.9 2.5-8.8c1.1-2.8 2.6-5.5 4.2-8.1s3.3-5.1 5.3-7.5c3.9-4.7 8.2-9 13-12.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000180344080571307396890000001553088171606771092_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000158716178448601472910000002950342942288804737_" x1={69.222} x2={87.502} y1={84.54} y2={81.97} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M91.8 39.4c-2.3 1.9-4.4 4-6.5 6.2s-4 4.5-5.8 6.9c-3.6 4.8-6.7 10-8.7 15.6s-3 11.7-2.1 17.6c.2 1.5.5 2.9.8 4.4.2.7.4 1.4.7 2.1.1.3.2.7.3 1.1l.4 1c1.1 2.8 2.7 5.4 4.3 7.9-3.5-4.8-6.2-10.4-7-16.5-.9-6 0-12.2 2.1-17.8 2.1-5.7 5.2-10.9 8.9-15.7s7.9-9.1 12.6-12.8" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000158716178448601472910000002950342942288804737_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000042709483959167369590000015829665937038741158_" x1={65.391} x2={82.441} y1={82.192} y2={79.792} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M86.7 41.9c-2.3 1.9-4.4 4-6.4 6.2q-3 3.3-5.7 6.9c-3.5 4.8-6.4 10.1-8.2 15.7q-1.35 4.2-1.8 8.7c-.2 1.5-.1 2.9-.1 4.4.1 1.5.2 2.9.5 4.4.2 1.5.7 2.9 1.1 4.3.5 1.4 1 2.8 1.6 4.1 1.2 2.7 2.8 5.2 4.5 7.7-3.6-4.7-6.4-10.2-7.4-16.1-.3-1.5-.4-3-.6-4.4 0-1.5-.1-3 .1-4.5.2-3 .8-5.9 1.7-8.8 1.9-5.7 4.8-11 8.4-15.8 3.6-4.7 7.7-9.1 12.3-12.8" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000042709483959167369590000015829665937038741158_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000054976447987196440210000016743185963945615037_" x1={61.51} x2={77.37} y1={79.854} y2={77.624} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M81.6 44.3c-2.2 1.9-4.3 4-6.3 6.2s-3.8 4.5-5.5 6.9c-3.3 4.8-6 10.1-7.6 15.8-.8 2.8-1.3 5.7-1.3 8.7-.1 2.9.1 5.9.8 8.7s1.6 5.7 3 8.3c1.2 2.7 2.9 5.1 4.6 7.5-3.6-4.6-6.6-9.9-7.9-15.7-.7-2.9-1-5.8-.9-8.8s.5-5.9 1.3-8.8c1.6-5.7 4.4-11 7.8-15.8 3.5-4.8 7.5-9.2 12-13" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000054976447987196440210000016743185963945615037_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000127044741477657322890000015365947656211579303_" x1={57.611} x2={72.311} y1={77.517} y2={75.457} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M76.5 46.8c-2.2 1.9-4.2 4-6.2 6.2s-3.7 4.5-5.3 7c-3.2 4.9-5.7 10.2-7 15.9-1.4 5.7-1.2 11.7.3 17.3q1.2 4.2 3.3 8.1c.6 1.3 1.5 2.5 2.2 3.8.8 1.2 1.7 2.4 2.6 3.6-3.7-4.5-6.7-9.7-8.3-15.3s-1.7-11.7-.4-17.4 3.9-11.1 7.2-16c3.2-4.9 7.2-9.4 11.6-13.2" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000127044741477657322890000015365947656211579303_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000110441359467876194630000014203643711580528777_" x1={53.641} x2={67.961} y1={75.211} y2={73.201} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M71.4 49.3c-2.2 1.9-4.2 4-6 6.2-1.9 2.2-3.6 4.5-5.1 7-3.1 4.9-5.4 10.3-6.4 16-.5 2.8-.7 5.7-.5 8.6s.8 5.7 1.6 8.5c1.8 5.5 4.9 10.5 8.5 15-3.8-4.4-6.9-9.4-8.7-14.9-.9-2.8-1.5-5.6-1.7-8.5s0-5.8.5-8.7c1-5.7 3.4-11.2 6.5-16 3.2-4.9 6.9-9.4 11.3-13.2" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000110441359467876194630000014203643711580528777_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000013191866474001226690000009763890065513665963_" x1={73.94} x2={124.55} y1={151.014} y2={143.904} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M130.7-39.7c-.6 9.4-3.2 18.7-7.2 27.3-.5 1.1-1 2.1-1.6 3.2s-1 2.2-1.6 3.2-1.2 2.1-1.8 3.1l-2 3c-.6 1-1.4 1.9-2.1 2.9-.7.9-1.4 1.9-2.2 2.8l-4.8 5.2-19.3 20.7-2.4 2.6c-.8.8-1.7 1.6-2.6 2.5l-5.2 4.9c-3.5 3.2-6.9 6.5-10.4 9.7 3.3-3.4 6.7-6.7 10-10.1l5-5 2.5-2.5 2.4-2.6 19.1-20.9 4.8-5.2c.8-.8 1.5-1.8 2.2-2.7s1.5-1.8 2.1-2.8c2.8-3.8 5-7.9 7.1-12.1s3.8-8.6 5.1-13.1c1.4-4.7 2.5-9.3 2.9-14.1" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000013191866474001226690000009763890065513665963_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000032634043198740669700000018081684696436029321_" x1={93.65} x2={157.53} y1={156.532} y2={147.552} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M162.9-36.2c-2.4 3.3-5 6.6-7.5 9.9s-5.1 6.5-7.8 9.7c-2.6 3.2-5.3 6.4-8.1 9.5-1.4 1.5-2.8 3.1-4.3 4.5-.7.7-1.5 1.5-2.3 2.2s-1.6 1.4-2.7 1.9l.2-.1c-3.5 3.2-7 6.3-10.5 9.4l-10.5 9.4-10.6 9.3c-3.6 3.1-7.1 6.2-10.7 9.2 3.4-3.3 6.8-6.5 10.3-9.7l10.3-9.6 10.4-9.5c3.5-3.2 6.9-6.3 10.4-9.5l.1-.1.1-.1c.8-.3 1.6-1 2.4-1.6s1.5-1.4 2.3-2.1c1.5-1.4 2.9-2.9 4.3-4.5 2.8-3.1 5.5-6.2 8.2-9.3 5.5-6.2 10.7-12.5 16-18.9" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000032634043198740669700000018081684696436029321_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000141429599910584086970000016326063545142021022_" x1={116.159} x2={201.75} y1={156.682} y2={144.662} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="m206.3-26.6-11.7 7.5-11.8 7.4C175-6.8 167.1-1.9 159.2 3l-23.8 14.5-11.9 7.2c-4 2.4-8 4.8-12 7.1 3.9-2.6 7.8-5.1 11.7-7.6l11.8-7.5L158.6 2c7.9-4.8 15.8-9.7 23.8-14.5l11.9-7.1c4-2.3 8-4.7 12-7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000141429599910584086970000016326063545142021022_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000021088454656899917470000000295290509848013500_" x1={127.849} x2={201.219} y1={147.587} y2={137.277} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M204.3-8.3c-3.3 1.7-6.5 3.4-9.8 5.1l-9.9 4.9c-6.6 3.3-13.2 6.5-19.8 9.7-6.6 3.1-13.3 6.4-19.9 9.5l-10 4.6c-3.4 1.5-6.7 3-10.1 4.5 3.3-1.7 6.5-3.4 9.8-5.1l9.9-4.9c6.6-3.3 13.2-6.5 19.8-9.7S177.6 4 184.2.9l10-4.6c3.4-1.6 6.7-3.1 10.1-4.6" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000021088454656899917470000000295290509848013500_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000183947926465980159440000002999772177460322461_" x1={135.271} x2={198.141} y1={139.43} y2={130.59} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M200.2 5.7c-2.2 1.4-4.4 2.7-6.7 3.9s-4.6 2.4-6.9 3.5c-2.4 1.1-4.7 2.1-7.2 2.9s-5 1.5-7.6 1.9h.1l-9.7 3c-3.2 1-6.5 2-9.7 3.1-3.2 1-6.5 2.1-9.7 3.2s-6.4 2.2-9.5 3.7c1.5-.9 3-1.6 4.6-2.3s3.1-1.4 4.7-2l9.6-3.6c3.2-1.1 6.4-2.2 9.7-3.2 3.2-1.1 6.5-2.1 9.8-3h.2c2.5-.3 5-1 7.4-1.8q3.6-1.2 7.2-2.7c2.4-1 4.7-2.1 7-3.2 2.1-1.1 4.4-2.3 6.7-3.4" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000183947926465980159440000002999772177460322461_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000091728045093833724110000005043616926842466492_" x1={148.999} x2={200.469} y1={135.12} y2={127.89} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M202.2 11.1c-2.2 1-4.5 2-6.7 3l-6.8 2.9c-4.5 1.9-9.1 3.8-13.6 5.6l-6.9 2.7c-2.3.8-4.6 1.7-6.9 2.4l-7 2.3c-2.3.7-4.7 1.5-7 2.2 2.3-1 4.6-1.8 6.8-2.8L161 27c2.3-.9 4.6-1.7 6.9-2.6l6.8-2.8c4.6-1.8 9.1-3.6 13.7-5.4l6.9-2.6c2.2-.8 4.5-1.6 6.9-2.5" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000091728045093833724110000005043616926842466492_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000103235261924536140060000012863108739512321967_" x1={157.24} x2={193.64} y1={72.563} y2={67.453} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M196.1 66c-2.1 1-4 2.1-5.9 3.4-1.9 1.2-3.7 2.6-5.4 4.1-3.4 2.9-6.6 6.2-9.4 9.7l-2.1 2.7-.5.7-.5.7c-.4.4-.7.9-1.1 1.3-1.5 1.7-3.1 3.4-4.8 4.9s-3.5 3-5.4 4.2-4 2.3-6.3 2.7c2.2-.7 4.1-1.8 6-3.2 1.8-1.3 3.5-2.8 5.1-4.4s3.1-3.3 4.6-5l1.1-1.3.5-.7.5-.7c.7-.9 1.3-1.9 2.1-2.8 2.9-3.6 6.1-6.9 9.8-9.7 1.8-1.4 3.7-2.7 5.7-3.8 1.8-1 3.9-2.1 6-2.8" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000103235261924536140060000012863108739512321967_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000069356430970313891070000017095524843791479981_" x1={145.821} x2={191.321} y1={56.51} y2={50.12} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M193.7 85.2q-3.6.9-6.9 2.4c-2.2.9-4.4 1.9-6.6 3.1q-6.45 3.45-12.3 7.8c-3.9 2.9-7.7 6-11.8 8.7-4 2.8-8.1 5.4-12.5 7.6 2.1-1.3 4.1-2.7 6.1-4.1s4-2.8 5.9-4.3 3.9-2.9 5.8-4.4 3.8-3.1 5.8-4.5c4-2.9 8.1-5.5 12.6-7.6 4.4-2.1 9-4 13.9-4.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000069356430970313891070000017095524843791479981_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000068667076761660890720000009879279204665902239_" x1={133.359} x2={189.959} y1={45.397} y2={37.447} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M192.2 99c-4.1.8-8.1 1.6-12.1 2.5-2 .5-4 .9-6 1.5-1.9.6-4 1.2-5.6 2.1l-6.2 3.1c-2.1 1.1-4.1 2-6.2 3.1-4.1 2-8.3 4.1-12.4 6-2 1.3-4.1 2.6-6.1 3.8s-4.1 2.5-6.2 3.7c1.9-1.4 3.9-2.8 5.9-4.2s4-2.7 5.9-4.1c4.1-2.2 8.2-4.2 12.3-6.3 2.1-1 4.1-2.1 6.2-3.1l6.2-3c1.9-1.1 3.9-1.6 5.9-2.1s4.1-.9 6.1-1.3c4.1-.7 8.2-1.3 12.3-1.7" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000068667076761660890720000009879279204665902239_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000143617112646840403060000014163590486227265195_" x1={122.012} x2={189.062} y1={39.057} y2={29.637} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M191.2 107.3c-3.1.4-6.3.8-9.4 1.3s-6.2 1.1-9.2 1.9c-6.1 1.5-12.2 3.4-17.5 6.6-5.2 3.6-10.9 6.6-16.8 8.8-5.9 2.3-12.1 3.8-18.4 4.8 3.1-.7 6.2-1.4 9.1-2.4 3-.9 6-2 8.9-3.2s5.8-2.5 8.5-4c1.4-.7 2.7-1.5 4.1-2.3.7-.4 1.3-.8 1.9-1.3l2-1.3q4.2-2.4 8.7-3.9c3-1 6.1-1.9 9.2-2.5 6.3-1.5 12.6-2.3 18.9-2.5" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000143617112646840403060000014163590486227265195_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000132792069513260023680000001757734058546777733_" x1={-2.181} x2={156.989} y1={63.239} y2={40.869} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M-11.4 158.1c14.6-9.8 29.3-19.4 44-29l22.2-14.3L77 100.6l44.4-28.4c14.8-9.5 29.8-18.7 44.7-28l.1.1c-14.9 9.4-29.8 18.7-44.5 28.4l-44.2 28.7-22.1 14.4-22.2 14.3c-14.8 9.4-29.6 18.9-44.6 28" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000132792069513260023680000001757734058546777733_)"
    }} /><linearGradient id="Wellness_front_svg__SVGID_00000065037770337970979390000006589603481964536452_" x1={-8.222} x2={77.878} y1={31.684} y2={18.814} gradientTransform="matrix(1 0 0 -1 0 153.276)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
        stopColor: "#a28240"
      }} /><stop offset={0} style={{
        stopColor: "#b59452"
      }} /><stop offset={0} style={{
        stopColor: "#d0ac6a"
      }} /><stop offset={0} style={{
        stopColor: "#e1bb79"
      }} /><stop offset={0} style={{
        stopColor: "#e7c17f"
      }} /><stop offset={0} style={{
        stopColor: "#e2bd7b"
      }} /><stop offset={0.08} style={{
        stopColor: "#c8a565"
      }} /><stop offset={0.16} style={{
        stopColor: "#b29253"
      }} /><stop offset={0.26} style={{
        stopColor: "#a18345"
      }} /><stop offset={0.38} style={{
        stopColor: "#95783c"
      }} /><stop offset={0.54} style={{
        stopColor: "#8e7236"
      }} /><stop offset={1} style={{
        stopColor: "#8d7135"
      }} /></linearGradient><path d="M-11.8 157.5c3.4-3.2 7-6.1 10.6-9 3.6-2.8 7.3-5.6 11.1-8.2s7.7-5.1 11.6-7.4c4-2.3 8-4.6 11.9-7l11.8-7.1 11.9-7c7.9-4.7 15.9-9.2 24-13.7l.3.5-11.4 7.8c-3.8 2.6-7.5 5.3-11.3 7.9l-11.3 7.9L36 130c-3.8 2.6-7.5 5.3-11.3 7.9s-7.6 5.1-11.6 7.5-8 4.6-12.1 6.7-8.2 4.2-12.6 5.9z" style={{
      fill: "url(#Wellness_front_svg__SVGID_00000065037770337970979390000006589603481964536452_)"
    }} /></g><path d="M209.6 22.2c.3.4.6.9.8 1.4s.3 1.1.3 1.6-.1 1.1-.3 1.6-.4 1-.7 1.4c-.4.6-.3 1.4.3 1.9.6.4 1.4.3 1.9-.3s.9-1.4 1.1-2.2c.3-.8.4-1.6.4-2.5s-.1-1.7-.4-2.5-.6-1.5-1.1-2.2c-.4-.6-1.3-.7-1.9-.3-.7.7-.8 1.6-.4 2.1M214.2 19.8c1 1.6 1.6 3.5 1.6 5.5s-.6 3.9-1.6 5.5c-.4.6-.2 1.4.4 1.8s1.4.2 1.8-.4c1.2-2 2-4.4 2-6.9s-.7-4.9-2-6.9c-.4-.6-1.2-.8-1.8-.4-.6.3-.8 1.2-.4 1.8M219 17.3c1.4 2.4 2.2 5.1 2.2 8.1s-.8 5.7-2.2 8.1c-.4.6-.2 1.4.5 1.8.6.4 1.4.2 1.8-.5 1.6-2.8 2.5-6 2.5-9.4s-.9-6.6-2.5-9.4c-.4-.6-1.2-.8-1.8-.5s-.9 1.1-.5 1.8" className="Wellness_front_svg__st50" /><path d="M223.8 14.7c1.8 3.1 2.8 6.7 2.8 10.6s-1 7.5-2.8 10.6c-.4.6-.1 1.4.5 1.8s1.4.1 1.8-.5c2-3.5 3.1-7.6 3.1-11.9s-1.1-8.4-3.1-11.9c-.4-.6-1.2-.9-1.8-.5-.7.4-.9 1.2-.5 1.8M209.6 22.2c.3.4.6.9.8 1.4s.3 1.1.3 1.6-.1 1.1-.3 1.6-.4 1-.7 1.4c-.4.6-.3 1.4.3 1.9.6.4 1.4.3 1.9-.3s.9-1.4 1.1-2.2c.3-.8.4-1.6.4-2.5s-.1-1.7-.4-2.5-.6-1.5-1.1-2.2c-.4-.6-1.3-.7-1.9-.3-.7.7-.8 1.6-.4 2.1M214.2 19.8c1 1.6 1.6 3.5 1.6 5.5s-.6 3.9-1.6 5.5c-.4.6-.2 1.4.4 1.8s1.4.2 1.8-.4c1.2-2 2-4.4 2-6.9s-.7-4.9-2-6.9c-.4-.6-1.2-.8-1.8-.4-.6.3-.8 1.2-.4 1.8" className="Wellness_front_svg__st50" /><path d="M219 17.3c1.4 2.4 2.2 5.1 2.2 8.1s-.8 5.7-2.2 8.1c-.4.6-.2 1.4.5 1.8.6.4 1.4.2 1.8-.5 1.6-2.8 2.5-6 2.5-9.4s-.9-6.6-2.5-9.4c-.4-.6-1.2-.8-1.8-.5s-.9 1.1-.5 1.8" className="Wellness_front_svg__st50" /><path d="M223.8 14.7c1.8 3.1 2.8 6.7 2.8 10.6s-1 7.5-2.8 10.6c-.4.6-.1 1.4.5 1.8s1.4.1 1.8-.5c2-3.5 3.1-7.6 3.1-11.9s-1.1-8.4-3.1-11.9c-.4-.6-1.2-.9-1.8-.5-.7.4-.9 1.2-.5 1.8" className="Wellness_front_svg__st50" /></svg>;
export default SvgWellnessfront;